import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Outlet } from 'react-router';
import Wrapper from 'common/navigation/wrapper';
import MainMenu from 'common/navigation/containers/main-menu-container';
import SubMenu from 'common/navigation/components/sub-menu';
import WorklistContainer from './worklist-container';

const WorklistRoutes = ({ intl }) => {
  const renderMenu = (actionButtons, extraLinks = []) =>
    <MainMenu type='worklists' actionButtons={actionButtons}>
      <SubMenu
        hasInfo={false}
        hasDashboard={false}
        extraLinks={extraLinks}
        actionButtons={actionButtons}
      />
    </MainMenu>;
  return (
    <Wrapper title={intl.formatMessage({ id: 'common.titles.WORKLIST' })}>
      <WorklistContainer renderMenu={renderMenu} />
      <Outlet />
    </Wrapper>
  );
};

WorklistRoutes.propTypes = {
  intl: PropTypes.object,
};

export default injectIntl(WorklistRoutes);
